// 3 digits, no spaces or dashes

const usaPostalCodePattern = /^\d{5}([ \-]\d{4})?$/;

const threeDigitCountries = ['FO', 'GN', 'IS', 'LS', 'MG', 'OM', 'PG', 'PS'];

// 4 digits, no spaces or dashes
const fourDigitCountries = [
  'AF',
  'AM',
  'AT',
  'AU',
  'AZ',
  'BD',
  'BE',
  'BG',
  'CC',
  'CH',
  'CK',
  'CV',
  'CY',
  'DK',
  'ET',
  'GE',
  'GW',
  'HM',
  'HT',
  'HU',
  'LR',
  'LU',
  'MK',
  'MZ',
  'NE',
  'NF',
  'NO',
  'NZ',
  'PA',
  'PH',
  'PY',
  'PY',
  'SI',
  'SJ',
  'SV',
  'TN',
  'VE',
  'ZA',
];

// 5 digits, no spaces or dashes
const fiveDigitCountries = [
  'BA',
  'BL',
  'BT',
  'BU',
  'CR',
  'CS',
  'CU',
  'DE',
  'DO',
  'DZ',
  'EE',
  'ES',
  'FI',
  'GT',
  'HN',
  'HR',
  'IC',
  'ID',
  'IQ',
  'IT',
  'JO',
  'KE',
  'KR',
  'KW',
  'LA',
  'LK',
  'MA',
  'MF',
  'MM',
  'MN',
  'MU',
  'MV',
  'MX',
  'MY',
  'NA',
  'NI',
  'NP',
  'PE',
  'PK',
  'PK',
  'RS',
  'SA',
  'SD',
  'SN',
  'SO',
  'TH',
  'TR',
  'TZ',
  'UA',
  'UY',
  'VN',
  'XK',
  'YU',
  'ZM',
];

// 5 digits, "3digits space 2 digits" like Sweden
const fiveDigitWithSpaceCountries = ['CZ', 'GR', 'SE', 'SK'];

// 6 digits, no spaces or dashes
const sixDigitCountries = [
  'BY',
  'CN',
  'CO',
  'EC',
  'IN',
  'KG',
  'KH',
  'KZ',
  'NG',
  'RO',
  'RU',
  'SG',
  'TJ',
  'TM',
  'TT',
  'UZ',
];

const sevenDigitCountries = ['EG'];

const POSTALCODE_VALIDATION_REGEX: { [key: string]: RegExp | undefined } = {
  AD: /^AD\d{3}$/,
  AI: /^(AI-)?2640$/,
  AQ: /^BIQQ ?1ZZ$/,
  AR: /^([A-HJ-NP-Z])?\d{4}([A-Z]{3})?$/,
  AS: /^96799(-?\d{4})?$/,
  AX: /^22\d{3}$/,
  BB: /^(BB)?\d{5}$/,
  BH: /^(1[0-2]|[2-9])\d{2}$/,
  BM: /^[A-Za-z]{2}[ ]?[A-Za-z0-9]{2}$/,
  BN: /^[BKTP][A-Z][ ]?\d{4}$/,
  BR: /^\d{5}[\-]?\d{3}$/,
  CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/,
  CC: /^6799$/,
  CL: /^\d{7}$/,
  CP: /^98799$/,
  CX: /^6798$/,
  DG: /^[bB]{2}9[dD] ?1[zZ]{2}$/,
  FK: /^FIQQ 1ZZ$/,
  FM: /^(9694[1-4])([ \-]\d{4})?$/,
  FR: /^\d{2}[ ]?\d{3}$/,
  GB: /^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$/i,
  GF: /^973\d{2}$/,
  GG: /^GY([0-9]|10)[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
  GI: /^GX11[ ]?1AA$/,
  GL: /^39\d{2}$/,
  GP: /^971\d{2}$/,
  GS: /^SIQQ 1ZZ$/,
  GU: /^969[123]\d([ \-]\d{4})?$/,
  IE: /^(?:([AC-FHKNPRTV-Yac-fhknprtv-y][0-9]{2}|[Dd]6[Ww])[ -]?[0-9AC-FHKNPRTV-Yac-fhknprtv-y]{4})?$|^$/,
  IL: /^\d{7}$|^\d{5}$/,
  IM: /^IM\d\d?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
  IO: /^BBND ?1ZZ$/,
  IR: /^\d{5}-?\d{5}$/,
  JE: /^JE\d[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
  JM: /^([1-9]|1[0-9]|20?)?$/, // 1-20 or empty
  JP: /^(\d{3}-\d{4})|^(\d{7})$/,
  JT: /^96898$/,
  KY: /^KY\d-?\d{4}$/,
  LB: /^\d{4}( ?\d{4})?$/,
  LC: /^LC\d{2}\s{1,2}\d{3}$/,
  LI: /^(948[5-9])|(949[0-8])$/,
  LT: /^(LT-)?\d{5}$/,
  LV: /^(LV-)?\d{4}$/,
  MC: /^980\d{2}$/,
  MD: /^(MD-)?\d{4}$/,
  ME: /^8\d{4}$/,
  MH: /^969[67]\d([ \-]\d{4})?$/,
  MI: /^96898$/,
  MP: /^9695[012]([ \-]\d{4})?$/,
  MQ: /^972\d{2}$/,
  MS: /^MSR\d{4}$/,
  MT: /^[A-Z]{2,3}[ ]?\d{2,4}$/,
  NC: /^988\d{2}$/,
  NF: /^2899$/,
  NL: /^\d{4}[ ]?[A-Z]{2}$/,
  OM: /^(PC )?\d{3}$/,
  PF: /^987\d{2}$/,
  PL: /^\d{2}-?\d{3}$/,
  PM: /^9[78]5\d{2}$/,
  PN: /^PCRN\s1ZZ$/,
  PR: usaPostalCodePattern,
  PT: /^\d{4}([\-]\d{3})$/,
  PW: /^(96939|96940)([ \-]\d{4})?$/,
  RE: /^974\d{2}$/,
  RS: /^\d{5,6}$/,
  SH: /^(STHL|ASCN|TDCU)\s1ZZ$/,
  SM: /^4789\d$/,
  SZ: /^[HLMS]\d{3}$/,
  TC: /^TKCA 1ZZ$/,
  TW: /^\d{3}(\d{2,3})?$/,
  UM: /^96898$/,
  US: usaPostalCodePattern,
  VA: /^00120$/,
  VG: /^VG11[123456]0$/,
  VI: /^008(([0-4]\d)|(5[01]))([ \-]\d{4})?$/,
  WF: /^986\d{2}$/,
  WS: /^[a-zA-Z]{2}\d{4}$/,
  YT: /^976\d{2}$/,
};
threeDigitCountries.forEach(country => {
  POSTALCODE_VALIDATION_REGEX[country] = /^\d{3}$/;
});
fourDigitCountries.forEach(country => {
  POSTALCODE_VALIDATION_REGEX[country] = /^\d{4}$/;
});
fiveDigitCountries.forEach(country => {
  POSTALCODE_VALIDATION_REGEX[country] = /^\d{5}$/;
});
fiveDigitWithSpaceCountries.forEach(country => {
  POSTALCODE_VALIDATION_REGEX[country] = /^\d{3}[ ]?\d{2}$/;
});
sixDigitCountries.forEach(country => {
  POSTALCODE_VALIDATION_REGEX[country] = /^\d{6}$/;
});
sevenDigitCountries.forEach(country => {
  POSTALCODE_VALIDATION_REGEX[country] = /^\d{7}$/;
});

export const getPostalCodeValidationRegexByCountryCode = (countryCode: string) => {
  return POSTALCODE_VALIDATION_REGEX[countryCode] || RegExp('');
};

type PostalCodeConfigOptions = {
  mask: string;
} & Pick<React.InputHTMLAttributes<HTMLInputElement>, 'inputMode' | 'type'>;

const baseNumericOptions = {
  type: 'text',
  inputMode: 'numeric',
} as const;

const POSTALCODE_CONFIG: {
  [key: string]: PostalCodeConfigOptions;
} = {
  CA: {
    mask: 'a0a 0a0',
    type: 'text',
  },
  FR: {
    mask: '00000',
    ...baseNumericOptions,
  },
  IR: {
    mask: '00000-00000',
    ...baseNumericOptions,
  },
  LT: {
    mask: 'LT-00000',
    ...baseNumericOptions,
  },
  LV: {
    mask: 'LV-0000',
    ...baseNumericOptions,
  },
  JP: {
    mask: '000-0000',
    ...baseNumericOptions,
  },
  KY: {
    mask: 'KY0-0000',
    ...baseNumericOptions,
  },
  JM: {
    mask: '[0][0]', // zero or one or two digits
    ...baseNumericOptions,
  },
  MD: {
    mask: 'MD-0000',
    ...baseNumericOptions,
  },
  NL: {
    mask: '0000 aa',
    type: 'text',
  },
  PL: {
    mask: '00-000',
    ...baseNumericOptions,
  },
  PT: {
    mask: '0000-000',
    ...baseNumericOptions,
  },
};

threeDigitCountries.forEach(country => {
  POSTALCODE_CONFIG[country] = {
    mask: '000',
    ...baseNumericOptions,
  };
});
fourDigitCountries.forEach(country => {
  POSTALCODE_CONFIG[country] = {
    mask: '0000',
    ...baseNumericOptions,
  };
});
fiveDigitCountries.forEach(country => {
  POSTALCODE_CONFIG[country] = {
    mask: '00000',
    ...baseNumericOptions,
  };
});
fiveDigitWithSpaceCountries.forEach(country => {
  POSTALCODE_CONFIG[country] = {
    mask: '000 00',
    ...baseNumericOptions,
  };
});
sixDigitCountries.forEach(country => {
  POSTALCODE_CONFIG[country] = {
    mask: '000000',
    ...baseNumericOptions,
  };
});
sevenDigitCountries.forEach(country => {
  POSTALCODE_CONFIG[country] = {
    mask: '0000000',
    ...baseNumericOptions,
  };
});

export const getPostalCodeFieldConfig = (countryCode: string) => {
  // if we didn't define mask for given country - allow anything
  return POSTALCODE_CONFIG[countryCode] || { mask: /.*/, type: 'text' };
};

export const getPostalCodePrefix = (countryCode: string) => {
  const config: { [key: string]: string } = {
    LT: 'LT',
    LV: 'LV',
    MD: 'MD',
  };
  return config[countryCode];
};
